// import axios from 'axios'

import { getWXConfig } from "../api/wxApi";

export default {
    wxShowMenu: function(title, desc, url, img) {
        let pageurl = window.location.href.split('#')[0]

        getWXConfig(pageurl).then(function(res) {

            var getMsg = res.data.data;

            wx.config({
                debug: false, //生产环境需要关闭debug模式

                appId: getMsg.appId, //appId通过微信服务号后台查看

                timestamp: getMsg.timestamp, //生成签名的时间戳

                nonceStr: getMsg.nonceStr, //生成签名的随机字符串

                signature: getMsg.signature, //签名

                jsApiList: [ //需要调用的JS接口列表

                    'updateAppMessageShareData', //分享给好友

                    'updateTimelineShareData', //分享到朋友圈

                    'onMenuShareTimeline',

                    'onMenuShareAppMessage',

                ],

            });

            wx.ready(function() {
                //检测接口是否正常
                wx.checkJsApi({
                    jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareTimeline', 'onMenuShareAppMessage'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                    success: function(res) {
                        // 以键值对的形式返回，可用的api值true，不可用为false
                        // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
                    },
                });
                //分享到朋友圈
                wx.updateTimelineShareData({

                    title: title, // 分享标题

                    desc: desc, //分享描述

                    link: url, // 分享链接

                    imgUrl: img // 分享图标

                });

                //分享给朋友
                wx.updateAppMessageShareData({

                    title: title, // 分享标题

                    desc: desc, //分享描述

                    link: url, // 分享链接

                    imgUrl: img, // 分享图标

                });
                //分享到朋友圈
                wx.onMenuShareTimeline({

                    title: title, // 分享标题

                    desc: desc, //分享描述

                    link: url, // 分享链接

                    imgUrl: img // 分享图标

                });

                //分享给朋友
                wx.onMenuShareAppMessage({

                    title: title, // 分享标题

                    desc: desc, //分享描述

                    link: url, // 分享链接

                    imgUrl: img, // 分享图标

                });

            });

        })

    }
}